/**
 * Vocabulário compartilhado do fluxo de venda (item + produto embutido).
 *
 * O status técnico do produto (CR/ED/RE/DI) nunca chega cru na tela nova:
 * para quem cadastra existem só três estados — publicado, rascunho e
 * despublicado — mais a ausência de produto ("sem anúncio").
 */

export const SALE_STATUS_META = {
  RE: { key: 'published', variant: 'success', icon: 'CheckCircleIcon' },
  CR: { key: 'draft', variant: 'warning', icon: 'EditIcon' },
  ED: { key: 'draft', variant: 'warning', icon: 'EditIcon' },
  DI: { key: 'unpublished', variant: 'secondary', icon: 'EyeOffIcon' },
}

export function saleStatusMeta(saleRow) {
  if (!saleRow || !saleRow.status) {
    return { key: 'no_sale', variant: 'danger', icon: 'AlertCircleIcon' }
  }
  return SALE_STATUS_META[saleRow.status] || { key: 'draft', variant: 'warning', icon: 'EditIcon' }
}

/** R$ 1.234,56 — sem depender do util global, que formata a partir de string. */
export function formatPrice(value) {
  const number = Number(value)
  if (value === null || value === undefined || Number.isNaN(number)) {
    return null
  }
  return number.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

const MARKETPLACE_PATHS = {
  LES: 'search/class',
  SPL: 'search/plan',
  RSP: 'search/rental-space',
}

/**
 * Página pública do anúncio no marketplace (router em hash mode).
 * Sem VUE_APP_MARKETPLACE_URL o link simplesmente não é oferecido.
 */
export function marketplaceItemUrl(itemType, productId) {
  const base = process.env.VUE_APP_MARKETPLACE_URL
  const path = MARKETPLACE_PATHS[itemType]
  if (!base || !path || !productId) {
    return null
  }
  return `${String(base).replace(/\/+$/, '')}/#/${path}/${productId}`
}
